import React from 'react';
//import logo from './logo.svg';
import './App.css';
import SorterVisualizer from './SorterVisualizer/SorterVisualizer';

function App() {
  return (
    <div className="App">
      <SorterVisualizer />
    </div>

  );
}

export default App;
